import { render } from "./female.vue?vue&type=template&id=6c6ffff6"
import script from "./female.vue?vue&type=script&lang=js"
export * from "./female.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__